import { createFileRoute } from "@tanstack/react-router";
import { routeOptions } from "@/pages/kontakt";
import { withAlternates } from "@/lib/route-i18n";

export const Route = createFileRoute("/kontakt")(withAlternates(routeOptions, "/kontakt"));
